


































































import Vue from 'vue';
import { HTTP } from '@/utils/httpCommonUtil'
import VueSimpleSpinner from 'vue-simple-spinner'
import { BallPulseLoader } from 'vue-loaders';
import {adminRoles} from "@/enums/userRolesEnum";

export default Vue.component('facility-contact-control', {
  name: 'FacilityContactControl',
  props: {
    showDropdownOnStart: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    facilityContactId: {
      type: Number,
      required: false,
      default: 0
    },
    facilityContactErrorMessage: {
      type: String
    },
    facilityContactName: {
      type: String
    },
  },
  watch: {
    async facilityContactId() {
      if (this.facilityContactId) {
        await this.fetchById();
      } else {
        this.selectFacilityContact({});
      }
    }
  },
  computed: {
    isAuthorized() : boolean {
      return this.$store.getters['user/hasRole'](adminRoles);
    }
  },
  data () {
    return {
      showDropdown: false,
      loadingSearchResults: false,
      searchInput: '',
      performSearchTimeout: null as any,
      searchResults: [] as any[],
      searchCountResults: 0,
      allowForceResultsMaximum: 150,
      allowForceResults: false,
      processing: false,
      systemFacilityContactsFromServer: [],
      systemFacilityContactsFiltered: [],
      searchText: ''
    }
  },
  components: {
    VueSimpleSpinner,
    BallPulseLoader
  },
  created: async function () {
    if (this.facilityContactId) {
      await this.fetchById();
    }
    if (this.showDropdownOnStart) {
      this.showDropdown = true;
    }
  },
  mounted: function () {
    (this.$refs as any).search.focus();
    (this.$refs as any).search.select();
  },
  filters: {
    shortName (shortName: string ) {
      if (shortName && shortName.length) {
        return '(' + shortName + ')';
      }
      return '';
    },
    facilityContactNameDisplay (facilityContact: any ) {
      if (!facilityContact.firstName && !facilityContact.lastName) {
        return '';
      }
      let facilityContactDisplayName = facilityContact.firstName + ' ' + facilityContact.lastName;
      return facilityContact.title ? facilityContactDisplayName + ' | ' + facilityContact.title : facilityContactDisplayName;
    },
  },
  methods: {
    toggleDropdown() {
      if (this.disabled) {
        return;
      }
      this.showDropdown = !this.showDropdown;
      if (this.showDropdown) {

        this.searchFacilityContacts();

        setTimeout(() => {
          (this.$refs.search as any).focus();
          (this.$refs.search as any).select();
        }, 300);
      }
    },
    async fetchById () {
      if (!this.isAuthorized) {
        return;
      }
      try {
        this.processing = true;
        this.loadingSearchResults = true;
        const response = await HTTP.get(`/api/facilityContacts/${this.facilityContactId}/general-information`);
        this.processing = false;

        this.searchCountResults = 1;
        const onlyResult = response.data.data;
        this.searchResults = [onlyResult];
        this.selectFacilityContact(onlyResult);
        this.allowForceResults = true;
        this.loadingSearchResults = false;

      } catch (err) {
        this.loadingSearchResults = false;

        this.processing = false;
        // if there was an error, "notify" the error
        this.$notify({
          group: 'main',
          type: 'error',
          title: 'Error Getting Results',
          text: 'Something went wrong getting search results!',
          // duration: 5000
        });
      }
    },
    searchFacilityContacts (force: boolean = false) {
      let self = this;
      let forceResults = force;
      // clearTimeout(this.performSearchTimeout);
      if (this.processing){ return; }
      this.processing = true;
      this.performSearchTimeout = setTimeout(function () {
        let showLoadingSpinnerTimeout = setTimeout(function () {
          self.loadingSearchResults = true;
          // }, 1000);
        }, 0);
        let currentSearchInput = self.searchInput;
        HTTP.get('/api/facility-contact/search?facilityContactNameLike=' + self.searchInput + '&forceResults=' + forceResults)
          .then(function (response) {
            self.processing = false;
            let queryCountResults = response.data.data.count;
            self.searchCountResults = queryCountResults;
            self.searchResults = response.data.data.results;
            self.allowForceResults = queryCountResults < self.allowForceResultsMaximum;

            clearTimeout(showLoadingSpinnerTimeout);
            self.loadingSearchResults = false;

            if (self.searchInput !== currentSearchInput) {
              self.searchFacilityContacts(force);
            }
          })
          .catch(function () {
            clearTimeout(showLoadingSpinnerTimeout);
            self.loadingSearchResults = false;

            self.processing = false;
            // if there was an error, "notify" the error
            self.$notify({
              group: 'main',
              type: 'error',
              title: 'Error Getting Results',
              text: 'Searching facilityContacts failed.',
              // duration: 5000
            });
            // self.close();
          })
      }, 100);
    },
    searchTextChange () {
      let self = this as any;
      let tempSystemFacilityContactsFiltered: any[] = [];
      let tempSearchText = self.searchText.toLowerCase();
      for (let i = 0; i < self.systemFacilityContactsFromServer.length; i++) {
        if (self.systemFacilityContactsFromServer[i].searchText.indexOf(tempSearchText) > -1) {
          tempSystemFacilityContactsFiltered.push(self.systemFacilityContactsFromServer[i]);
        }
      }
      self.systemFacilityContactsFiltered = tempSystemFacilityContactsFiltered;
    },
    selectFacilityContact (facilityContact: any) {
      const toEmit = {facilityContactId: facilityContact.id, name: facilityContact.name };
      this.$emit('facilityContactSelected', toEmit);
      this.showDropdown = false;
    },
    cancel (event: any) {
      this.toggleDropdown();
      this.$emit('cancelEvent');
    }
  }
});



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/componentsReusable/FacilityContactControl.vue